<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Jenis Barang</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Nama Jenis Barang">
                        <b-form-input v-model="input.jenisBarang" name="jenisBarang" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Tipe Pinjaman">
                        <b-form-select v-model="input.tipePinjaman" name="tipePinjaman" :options="tipePinjaman" value-field="id" text-field="name" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group>
                        <label>Panduan Nama Tipe</label>
                        <b-input-group class="mb-3">
                            <b-form-input v-model="input.panduanNamaTipe" name="panduanNamaTipe" maxlength="255" ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">   
                    <label>Surat Edaran Jenis Barang</label>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDF">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">KELENGKAPAN BARANG</h6>
                    <div class="form-content-wrapper">   
                    <label>Surat Edaran Kelengkapan Barang</label>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf1">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDFKelengkapan">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
                </div>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addKelengkapan" name="kelengkapanAddBtn"><i class="fa fa-plus mr-2"></i>Kelengkapan</b-button>
                        <Kelengkapan v-for="item in input.kelengkapan" v-bind:key="item.index"
                            :kelengkapan="item" :length="input.kelengkapan.length" @remove="removeKelengkapan"  
                            :filePDF = "item.filePDF" 
                            @changeSEKelengkapan="changeSEKelengkapan"
                            @openModalPreviewPDFSpekKel="openModalPreviewPDFSpekKel"
                        />
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">SPESIFIKASI</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addSpesifikasi" name="spesifikasiAddBtn"><i class="fa fa-plus mr-2"></i>Spesifikasi</b-button>
                        <Spesifikasi :isInputJenis="isInputJenis" v-for="item in input.spesifikasi"
                                v-bind:key="item.index" 
                                v-bind:id="item.id"
                                :idSpesifikasi="item.id" 
                                @removeFoto="removeFoto" 
                                :fotoPendukung="item.fotoPendukung"
                                :filePDF = "item.filePDF"
                                :spesifikasi="item" :length="input.spesifikasi.length" 
                                @remove="removeSpesifikasi(item.index, item.id)" 
                                @showModalCam="openModalCam"
                                @showModalPreview="openModalPreview"
                                @changeSESpek="changeSESpek"
                                @openModalPreviewPDFSpekKel = "openModalPreviewPDFSpekKel"
                        />
                    </div>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button name="jenisBarangSubmitBtn" type="submit" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Jenis Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput jenis barang ini?" @submit="onSubmit" />

        <ModalConfirm  id="modal-hapus" title="Confirm Hapus Foto" desc="Foto Akan Terhapus Permanen" @submit=removeFotoPendukung />
        <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult"  />

           <!-- MODAL SHOW SE -->
           <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import { file } from '@babel/types';
import Kelengkapan from '../../../components/kelengkapan/Kelengkapan';
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi';
import ModalPreview from '../../../components/webcam/ModalPreview.vue';
import ModalWebCam from '../../../components/webcam/ModalWebCam.vue'

export default {
    name: 'input-jenis-barang',
    components: { 
        Kelengkapan, 
        Spesifikasi, 
        ModalPreview,
        ModalWebCam
    },
    data(){
        return{
            isInputJenis : true,
            initStatus: 0,
            isSubmitting: false,
            input:{
                jenisBarang: "",
                tipePinjaman: null,
                filePDF: [],
                filePDFKelengkapan: [],
                kelengkapan: [],
                spesifikasi: [],
                panduanNamaTipe: "",
            },

            indexKelengkapan: 0,
            indexSpesifikasi: 0,
            tipePinjaman: [],

            pdf:null,
            pdf1:null,

            status: 0 ,
            count: 1,

            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungId: null,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",
            isCreate: true,
            
            
            confirmDelId:null,
            confirmDelIndex:null,
            confirmDelIdSpesifikasi:null,

            activePdfPreview:""
        }
    }, 

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            
            let getTipePinjaman = this.$axios.get("jenis-pinjaman/").then(response => {
                this.tipePinjaman = response.data
            })

            Promise.all([getTipePinjaman]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        openModalPreview(idSpekFotoModPrev,idFotoModPrev,indexModPrev,name){
  
            let id = this.input.spesifikasi.findIndex(item => item.id == idSpekFotoModPrev)
            
            let index = this.input.spesifikasi[id].fotoPendukung.findIndex(item => item.index == indexModPrev)

            if(name != null){
                this.activeFotoPreview = this.$baseFilePath + this.input.spesifikasi[id].fotoPendukung[index].name
            }else{
                this.activeFotoPreview =  this.input.spesifikasi[id].fotoPendukung[index].activeFotoPendukungBase64 
            }
          
            this.$bvModal.show("modal-preview-gadai")
        },
        
        openModalCam(id,index){
            this.activeFotoPendukungId = id
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
                let id = this.input.spesifikasi.findIndex(item => item.id ==  this.activeFotoPendukungId)

                let index = this.input.spesifikasi[id].fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex)
    
                this.input.spesifikasi[id].fotoPendukung[index].fotoBarangPendukungBase64 = newResult
                this.input.spesifikasi[id].fotoPendukung[index].activeFotoPendukungBase64 = newResult
                this.input.spesifikasi[id].fotoPendukung[index].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.input.spesifikasi[id].fotoPendukung[index].checkFotoBarangPendukung = true
        },

        removeFoto(id , index ,idSpesifikasi){

            if(idSpesifikasi!=null){
                this.confirmDelId = id
                this.confirmDelIndex = index
                this.confirmDelIdSpesifikasi=idSpesifikasi
            }
            else{
                this.confirmDelId = id
                this.confirmDelIndex = index
            }
    
            this.$bvModal.show("modal-hapus")
        },

        removeFotoPendukung() {

            if(this.confirmDelIdSpesifikasi!=null){
     
               let spesifikasi = this.input.spesifikasi.filter(item => item.id == this.confirmDelIdSpesifikasi)[0]
               for(var fotoPendukung of spesifikasi.fotoPendukung){
   
                if(fotoPendukung.name == this.confirmDelIndex ){
                    fotoPendukung.hidden = true
                }
                }   
            }else{
   
                 let spesifikasi = this.input.spesifikasi.filter(item => item.id == this.confirmDelId)[0]
        
                let fotoPendukung = spesifikasi.fotoPendukung.filter(item => item.index != this.confirmDelIndex)
  
                let id = this.input.spesifikasi.findIndex(item => item.id == this.confirmDelId);

                this.input.spesifikasi[id].fotoPendukung = fotoPendukung
            }

            this.fotoPendukungError = false;
            this.$bvModal.hide("modal-hapus")
        },

        //----------------- Fungsi Tambah Hapus Data Kelengkapan & Spesifikasi -----------------
        
        addKelengkapan() {
     
            this.input.kelengkapan.unshift({ 
                index: this.indexKelengkapan, 
                id: 0, 
                data: "",
                filePDF: []
            })
            this.indexKelengkapan++
        },

        removeKelengkapan(index) {
            this.input.kelengkapan = this.input.kelengkapan.filter(item => item.index != index)
        },

        addSpesifikasi() {
            let count = this.count
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: count, 
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null,
                fotoPendukung: [],
                filePDF: []
            })
            this.count++
            this.indexSpesifikasi++
        },

        removeSpesifikasi(index) {
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != index)
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            let payload = new FormData()

            //----------------- Append Data Jenis Barang -----------------
            
            if (this.input.kelengkapan.length != 0) {
                for (var x of this.input.kelengkapan) {
                    payload.append("kelengkapanId", 0)
                    payload.append("kelengkapanName", x.name)
                }
            }

            //File PDF
        
            if( this.input.filePDF != null){

                for(var file of this.input.filePDF ){
                    payload.append("pdfFiles" , file)
                }
            }

            //Kelengkapan PDF
            
            if( this.input.filePDFKelengkapan != null){

            let payloadKelengkapan = new FormData()
            payloadKelengkapan.append("menu" , "kelengkapan0")
            payloadKelengkapan.append("jenis" , "kelengkapan")
            payload.append("suratKelengkapan" , "kelengkapan0")

            for(var file of this.input.filePDFKelengkapan ){
                
                if(file.size != null){
   
                    payloadKelengkapan.append("pdfFiles" , file)
                }
                else if (file.file.size != null){
     
                    payloadKelengkapan.append("pdfFiles" , file.file)       
                }
                else {
                    //Jika tidak Update Kirim File Kosong
                    let metadata = {
                        type: 'application/pdf'
                    }
                    let fileInput = new File([],"pdf",metadata)
                    payloadKelengkapan.append("pdfFiles" , fileInput)
                }
            }

            this.$axios.post("surat-edaran/insertOrUpdate/",payloadKelengkapan).then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                        console.log(error.response.data.reason)
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => {
                        
                    })
            }


            //jika 1 spek
            if (this.input.spesifikasi.length ==1){
   
                for (var x of this.input.spesifikasi) {
                    payload.append("spesifikasiId", 0)
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }
            
                
                    if(x.fotoPendukung.length != 0){
                        let jsonFoto = []
                            x.fotoPendukung.forEach(function(entry) {
                            jsonFoto.push(entry.activeFotoPendukungBase64)  
                            })
                            payload.append("spesifikasiFoto", JSON.stringify(jsonFoto))
                            this.status = 0      
                        }

                    payload.append("spesifikasiFoto", JSON.stringify([""]))


                     payload.append("suratSpek" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
           

                            for(var file of x.filePDF){
                           
                            if(file.size != null){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                            else if(file.file.url == null){
                                payloadSpesifikasi.append("pdfFiles", file.file)                 
                            }
                            else {
                                //Jika tidak Update Kirim File Kosong
                                let metadata = {
                                    type: 'application/pdf'
                                }
                                let fileInput = new File([],"pdf",metadata)
                                payloadSpesifikasi.append("pdfFiles" , fileInput)
                                }
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }
                }
            }

            //multi speks
            else if (this.input.spesifikasi.length != 0) {
    
                for (var x of this.input.spesifikasi) {
                    payload.append("spesifikasiId", 0)
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }
             

                     if(x.fotoPendukung.length != 0){
                        
                            let jsonFoto = []
                            x.fotoPendukung.forEach(function(entry) {
                            jsonFoto.push(entry.activeFotoPendukungBase64)  
                            })
                            payload.append("spesifikasiFoto", JSON.stringify(jsonFoto))
                            this.status = 0
                        
                    }

                    else{
                        payload.append("spesifikasiFoto", JSON.stringify([""]))
                    }

                        payload.append("suratSpek" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
       
                            for(var file of x.filePDF){
      
                            if(file.size != null){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                            else if(file.file.url == null){
                                payloadSpesifikasi.append("pdfFiles", file.file)                 
                            }
                            else {
                                //Jika tidak Update Kirim File Kosong
                                let metadata = {
                                    type: 'application/pdf'
                                }
                                let fileInput = new File([],"pdf",metadata)
                                payloadSpesifikasi.append("pdfFiles" , fileInput)
                                }
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }
                }
            }

            payload.append("name", this.input.jenisBarang)
            payload.append("panduanNamaTipe", this.input.panduanNamaTipe)
            payload.append("jenisPinjamanId", this.input.tipePinjaman)
    
            
            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true


            this.$axios.post("barang-jenis/", payload).then(response => {
                this.$helper.setFlash(`Pembuatan jenis barang baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        
        //----------------- Fungsi Lain -----------------

        openModalConfirm(){

            if(this.input.filePDF != null) {
                for(var file of this.input.filePDF){

                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            if(this.input.filePDFKelengkapan != null) {
                for(var file of this.input.filePDFKelengkapan){
   
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            for( var spesifikasi of this.input.spesifikasi){
      
                if(spesifikasi.filePDF != null){
                for(var file of spesifikasi.filePDF){
      
                       if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                        }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                    }
                }
            }

            this.$bvModal.show("modal-confirm-input")
        },

        //----------------- Fungsi SE -----------------

        toBase64(file) {
      
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        openModalPreviewPDF(pdf){

                 this.toBase64(pdf).then(async base64 => {   
              
                    this.activePdfPreview = base64
                })
            this.$bvModal.show("modal-SE")
        },

        //----------------- Fungsi SE Spesifikasi -----------------
        changeSESpek(idSpesifikasi,filePDF){
          
            let idx = this.input.spesifikasi.findIndex(item => item.id == idSpesifikasi)
            this.input.spesifikasi[idx].filePDF = filePDF
    
            
        },

        changeSEKelengkapan(index,filePDF){
           
            let idx = this.input.kelengkapan.findIndex(item => item.index == index)
            this.input.kelengkapan[idx].filePDF = filePDF
     
        },

        openModalPreviewPDFSpekKel(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

    },

    watch: {
       
        "pdf.file.files": function (newValue) {   
          
            let Pdfbase64 = []
            if(newValue.length != 0){
            let i = 0
                for(var file of newValue){
            
                Pdfbase64.push(file.file)
                }
         
            this.input.filePDF = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDF = null
            }
        },


        "pdf1.file.files": function (newValue) {   

            let Pdfbase64 = []
            if(newValue.length != 0){
            let i = 0
                for(var file of newValue){
                 
                Pdfbase64.push(file.file)
                }

            this.input.filePDFKelengkapan = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDFKelengkapan = null
            }
        },

    },
    
    created(){
        this.init()
    }
}
</script>
